var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextOutdent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.626 6.25a.625.625 0 01-.625.625H6.875a.625.625 0 010-1.25H15a.625.625 0 01.626.625zm-8.75-4.375H15a.625.625 0 100-1.25H6.875a.625.625 0 000 1.25zM15 10.625H1.25a.625.625 0 000 1.25H15a.625.625 0 100-1.25zM3.75 7.5a.625.625 0 00.442-1.067L1.509 3.75l2.684-2.682a.625.625 0 10-.885-.885L.183 3.308a.625.625 0 000 .885l3.125 3.125a.625.625 0 00.442.182z"
  })));
}
export default SvgTextOutdent;